import { toast } from "react-toastify";
import { timeToast } from "../../../Constant";

toast.configure();

const updateStatusDokumenTransaksi = async (axiosInstance, id, formData) => {
  return await axiosInstance.put(`statusdokumentransaksi/${id}`, formData);
};

export default updateStatusDokumenTransaksi;
